/**
 * getReviewAggregate() — pulls the live Google Places rating + count from
 * `window.__ATBB_REVIEWS__` (pinned by `/api/review-aggregate.js` at page
 * load time). Falls back to safe defaults if the script hasn't loaded yet
 * (SSR-like build, initial paint, network issue).
 *
 * The values feed:
 *  • LocalBusiness aggregateRating (SEOHead, sitewide)
 *  • Service aggregateRating (ServicePage, /services/*)
 *  • Service aggregateRating (ServiceSuburbPage, all 140 combos)
 */

const FALLBACK = {
  ratingValue: 5.0,
  reviewCount: 1,
};

export const getReviewAggregate = () => {
  if (typeof window === 'undefined') return FALLBACK;
  const live = window.__ATBB_REVIEWS__;
  if (!live || typeof live.reviewCount !== 'number' || typeof live.ratingValue !== 'number') {
    return FALLBACK;
  }
  return {
    ratingValue: live.ratingValue,
    reviewCount: live.reviewCount,
  };
};

/**
 * schemaAggregateRating() — returns a schema.org AggregateRating node
 * ready for direct inclusion in a JSON-LD `@graph`. Uses live data if
 * available, safe fallback otherwise.
 */
export const schemaAggregateRating = () => {
  const { ratingValue, reviewCount } = getReviewAggregate();
  return {
    '@type': 'AggregateRating',
    ratingValue: String(ratingValue.toFixed(1)),
    reviewCount: String(reviewCount),
    bestRating: '5',
    worstRating: '1',
  };
};
